<template>
  <v-dialog v-model="showModal" :max-width="'80%'" @keydown.esc="cancel">
    <v-card>
      <v-toolbar dark :color="'primary-main lighten-'" dense flat>
        <v-toolbar-title class="text-body-2 font-weight-bold text-white">
          WriteWise Quick-Start Tutorial Playlist: Mastering the Software in No Time
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="flex pa-4 black--text">
        <div class="grid gap-0.5 m-4">
          <div class="overflow-y-auto h-96">
            <div
              v-for="(item, index) in tutorials"
              :key="index"
              @click="playVideo(index)"
              class="cursor-pointer p-4 mb-4 border flex flex-col items-center !border-gray-200 hover:text-primary-main rounded-md hover:!border-primary-main duration-200"
              :class="selectedIndex === index ? '!bg-primary-main !text-white' : 'nav-link'"
            >
              <span class="text-sm text-center mt-2">{{ item.title }}</span>
            </div>
          </div>
        </div>
        <div class="flex-1 m-5">
          <iframe
            v-if="tutorials[selectedIndex]"
            :src="tutorials[selectedIndex].url"
            width="100%"
            height="380"
            frameborder="0"
            allowfullscreen
          ></iframe></div
      ></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          variant="flat"
          class="!py-3 !bg-primary-danger !text-white mr-4 mb-1 !rounded-xl !tracking-normal !capitalize !h-auto min-w-[120px]"
          @click.stop="cancel"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { Vue } from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';
import { usePayloadStore } from '@/stores/payload';

export default class Tutorials extends Vue {
  mounted() {}

  @Prop()
  public isTutorials: boolean = false;

  private payloadStore = usePayloadStore();

  public loadingResponse = false;

  get showModal() {
    return this.isTutorials;
  }

  set showModal(newValue) {
    this.$emit('update:modelValue', newValue);
  }
  public tutorials = [
    {
      title: 'Advantages of Generative Artificial Intelligence',
      url: 'https://writewise.blob.core.windows.net/tutorials/Advantages of Generative Artificial Intelligence.mp4'
    },
    {
      title: 'AI Paper Drafter',
      url: 'https://writewise.blob.core.windows.net/tutorials/01. AI Paper Drafter.mp4'
    },
    {
      title: 'Paper ChatGPT',
      url: 'https://writewise.blob.core.windows.net/tutorials/02. Paper ChatGPT.mp4'
    },
    {
      title: 'Bibliography Search',
      url: 'https://writewise.blob.core.windows.net/tutorials/03. Bibliography Search.mp4'
    },
    {
      title: 'Peer Review',
      url: 'https://writewise.blob.core.windows.net/tutorials/04. Peer Review.mp4'
    },
    {
      title: 'Paraphraser',
      url: 'https://writewise.blob.core.windows.net/tutorials/05. Paraphraser.mp4'
    },
    {
      title: 'Summarizer',
      url: 'https://writewise.blob.core.windows.net/tutorials/06. Summarizer.mp4'
    },
    {
      title: 'Academic Phrasebank',
      url: 'https://writewise.blob.core.windows.net/tutorials/07. Academic Phrasebank.mp4'
    },
    {
      title: 'Sentence Length',
      url: 'https://writewise.blob.core.windows.net/tutorials/08. Sentence Length.mp4'
    },
    {
      title: 'Plagiarism Checker',
      url: 'https://writewise.blob.core.windows.net/tutorials/10. Plagiarism Checker.mp4'
    },
    {
      title: 'Cover Letter',
      url: 'https://writewise.blob.core.windows.net/tutorials/11. Cover Letter.mp4'
    },
    {
      title: 'Journal Selector',
      url: 'https://writewise.blob.core.windows.net/tutorials/12. Journal Selector.mp4'
    }
  ];
  public selectedIndex: number = 0;

  public cancel() {
    this.showModal = false;
  }

  public playVideo(index: number) {
    this.selectedIndex = index;
  }
}
</script>
